import React, { useState, useEffect } from 'react';
import { Notifications, DataTable, FormComponent } from '../../../shared';
import { infoTechApi as api } from '../../../api/infoTech';
import { Button, Dialog, DialogActions, DialogContent, DialogTitle, IconButton } from '@material-ui/core';
import EditIcon from '@material-ui/icons/Edit';

const EditEntryModal = ({ open, onClose, onSave, entry }) => {
    const [formData, setFormData] = useState(null);

    useEffect(() => {
        if (entry) {
            setFormData({ [entry.field]: entry.value });
        }
    }, [entry]);

    if (!open) {
        return null;
    }

    const formFields = [
        {
            name: entry.field,
            inputElement: 'textEditor',
            label: entry.field.charAt(0).toUpperCase() + entry.field.slice(1),
            initialValue: entry.value,
            gridValue: 12,
        },
    ];

    const handleSave = async () => {
        const success = await onSave(formData);
        if (success) {
            onClose();
        }
    };

    return (
        <Dialog open={open} onClose={onClose} fullWidth maxWidth="md">
            <DialogTitle>Edit {entry.field}</DialogTitle>
            <DialogContent>
                <FormComponent formFields={formFields} onFormDataChange={setFormData} hideSubmit={true} />
            </DialogContent>
            <DialogActions>
                <Button onClick={onClose} color="secondary">
                    Cancel
                </Button>
                <Button onClick={handleSave} color="primary">
                    Save
                </Button>
            </DialogActions>
        </Dialog>
    );
};

let ViewKnowledgeBase = () => {
    let [rows, setRows] = useState([]);
    let [notification, setNotification] = useState({ text: null, level: null });
    const [editingEntry, setEditingEntry] = useState(null);

    const handleModalClose = () => {
        setEditingEntry(null);
    };

    const handleModalSave = async (formData) => {
        if (!editingEntry) return false;

        const { id, field } = editingEntry;
        const value = formData[field];

        let item = { [field]: value };
        let response = await api.updateKnowledgeBaseEntry(id, item);

        if (response.status === false) {
            setNotification({ text: 'Failed: ' + response.msg, level: 'error' });
            return false;
        }

        setNotification({ text: 'Entry updated successfully', level: 'success' });
        getRows();
        return true;
    };

    // Load  table
    let getRows = async () => {
        let response = await api.getKnowledgeBaseEntries();
        if (response.status === false) {
            setNotification({ text: 'No entries found ' + response.msg, level: 'error' });
            setRows([]);
            return;
        }

        setRows(response.data.rows);
    };

    const handleEditClick = (row, field) => {
        setEditingEntry({
            id: row.original.id,
            field: field,
            value: row.original[field],
        });
    };

    let columns = [
        { accessor: 'id', Header: 'ID' },
        { accessor: 'title', Header: 'Title', editable: true },
        { accessor: 'problem', Header: 'Problem', editable: true },
        { accessor: 'numTickets', Header: 'Num Tickets' },
        {
            accessor: 'investigation',
            Header: 'Investigation',
            Cell: ({ row }) => (
                <div style={{ display: 'flex', alignItems: 'flex-start' }}>
                    <div
                        style={{
                            flexGrow: 1,
                            maxHeight: '150px',
                            overflowY: 'auto',
                            border: '1px solid #ddd',
                            padding: '5px',
                            borderRadius: '4px',
                        }}
                        dangerouslySetInnerHTML={{ __html: row.original.investigation }}
                    />
                    <IconButton onClick={() => handleEditClick(row, 'investigation')} size="small">
                        <EditIcon />
                    </IconButton>
                </div>
            ),
        },
        {
            accessor: 'solution',
            Header: 'Solution',
            Cell: ({ row }) => (
                <div style={{ display: 'flex', alignItems: 'flex-start' }}>
                    <div
                        style={{
                            flexGrow: 1,
                            maxHeight: '150px',
                            overflowY: 'auto',
                            border: '1px solid #ddd',
                            padding: '5px',
                            borderRadius: '4px',
                        }}
                        dangerouslySetInnerHTML={{ __html: row.original.solution }}
                    />
                    <IconButton onClick={() => handleEditClick(row, 'solution')} size="small">
                        <EditIcon />
                    </IconButton>
                </div>
            ),
        },
        {
            accessor: 'remove',
            Header: 'Remove',
            Cell: ({ cell: { value: initialValue }, row, column, saveEdit, editable }) => {
                return (
                    <Button
                        disabled={row.original.numTickets > 0}
                        onClick={async () => {
                            let response = await api.deleteKnowledgeBaseEntry(row.original.id);

                            if (response.status === false) {
                                setNotification({ text: "Can't remove entry " + response.msg, level: 'error' });
                                return;
                            }

                            getRows();
                        }}
                    >
                        Remove
                    </Button>
                );
            },
        },
    ];

    useEffect(() => {
        getRows();
    }, []);

    return (
        <div>
            <h1>ITS Knowledge Base</h1>
            <Notifications options={notification} />
            <EditEntryModal
                open={!!editingEntry}
                onClose={handleModalClose}
                onSave={handleModalSave}
                entry={editingEntry}
            />
            <div>
                <DataTable
                    columns={columns}
                    data={rows}
                    editable={true}
                    initialState={{ pageSize: 25 }}
                    saveEdit={async ({ id, field, value, row }) => {
                        let item = {};
                        item[field] = value;

                        let response = await api.updateKnowledgeBaseEntry(id, item);

                        if (response.status === false) {
                            setNotification({ text: 'Failed: ' + response.msg, level: 'error' });
                            return;
                        }

                        getRows();
                    }}
                />
            </div>
        </div>
    );
};

export { ViewKnowledgeBase };
